import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";
  
  export const getAllSubjectBasedTeachers = async (Query) =>
    commonFetch(API_URLS.GET_ALL_SUBJECTS_TEACHER_APIURL, {
    method: "POST",
    body: Query,
    requiresAuth: true,
  });

